import template from './insuranceCreateApplication.html';
import controller from './insuranceCreateApplicationCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    modalData: '<',
  },
};
